
import React from 'react'
import { Link } from "react-router-dom";
import Icon from "./Icon";

interface ButtonProps {
	children: React.ReactNode;
	to?: string;
	className?: string;
	background?: string;
}


const Button: React.FC<ButtonProps> = ({ children, to, className, background }) => (
	<Link
		to={to || ""}
		style={{ background: background }}
		className={`flex flex-row justify-center items-center px-12 py-6 gap-3 self-stretch text-lg font-bold leading-5 text-center rounded-[50px] transition duration-200 ease-in-out hover:opacity-50 ${className}`}
	>
		<div className="inline-block">{children}</div>
		<Icon src="./assets/vector.svg" alt="Arrow icon" className="shrink-0 my-auto aspect-square fill-white w-[15px]" />
	</Link>
);

export default Button